import { VerticalContainer } from '@american-autonomy/ag-ui';

import InputLabelText from 'components/text/InputLabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithField: FunctionComponent<Props> = ({
    children,
    className = '',
    isPlain = false,
    label,
    testId = TEST_ID
}) => {
    const plainClass = isPlain ? styles.plain : '';
    const labelPlainClass = isPlain ? styles.labelPlain : '';

    return (
        <VerticalContainer
            className={`${className} ${styles.withField} ${plainClass}`}
            testId={testId}>
            <VerticalContainer className={`${styles.flex} ${labelPlainClass}`}>
                <InputLabelText text={label} />
            </VerticalContainer>

            {children}
        </VerticalContainer>
    );
};

export default WithField;
